import { type Lang, COPY, renderEm } from "../copy.js";
import { SectionEyebrow } from "./SectionEyebrow.js";

const MAPS_URL = "https://maps.app.goo.gl/kg6J9yZeThJy6fye7";

export function VenueBlock({ lang }: { lang: Lang }) {
  const t = COPY[lang];
  return (
    <section className="block">
      <div className="wrap">
        <SectionEyebrow num={t.venue.eyebrow.num} name={t.venue.eyebrow.name} />
        <h2 className="hd">{renderEm(t.venue.h)}</h2>
        <p className="lead">{t.venue.body}</p>

        <div className="venue-card">
          <div className="map-wrap">
            <img src="/venue-map.png" alt={t.venue.mapAlt} />
          </div>
          <div className="venue-body">
            <div className="name">{t.venue.name}</div>
            <div className="addr">{t.venue.addr}</div>
            <div className="venue-actions">
              <a className="btn primary" href={MAPS_URL} target="_blank" rel="noreferrer">
                {t.venue.maps} <span className="arrow">→</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
